import {
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react'

// const baseUrl = 'https://tpobacktest-jvbyy.ondigitalocean.app'
// const baseUrl = 'http://localhost:1111'
const baseUrl = 'https://tpomobi.shop'
const getDefaultYear = () => new Date().getFullYear()
const normalizeYear = (year) => {
  const y = Number(year)
  if (!Number.isInteger(y) || y < 2000 || y > 2100)
    return getDefaultYear()
  return y
}
const withYear = (body) => ({
  ...body,
  year: normalizeYear(body?.year),
})

export const mainApi = createApi({
  reducerPath: 'mainApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    findAllWords: builder.query({
      query: () => ({
        url: '/getProductsAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      transformResponse: (response) => response.reverse(),
      providesTags: [{ type: 'Products', id: 'Products' }],
    }),
    getSpoProductsFromContacts: builder.query({
      query: () => ({
        url: '/getSpoProductsFromContacts',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['PersonalSalesList'],
    }),

    getWhatsappMessages: builder.query({
      query: () => ({
        url: '/getWhatsappMessages',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['whatsappMessages'],
    }),
    getWhatsappMessageBotsChat: builder.query({
      query: () => ({
        url: '/getWhatsappMessageBotsChat',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['whatsappMessages'],
    }),
    getProductsLimit: builder.query({
      query: (query) => ({
        url: '/getProductsAdminLimit',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          limit: query.limit || 50,
          search: query.search || '',
          sku: query.sku || '',
        },
      }),
      providesTags: ['Products'],
    }),
    getProductsBySkus: builder.query({
      query: (query) => ({
        url: '/getProductsBySku',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          skus: query.skus || '',
        },
      }),
      providesTags: ['Products', 'Product'],
    }),
    getProductById: builder.query({
      query: (id) => ({
        url: `/getProductsAdmin/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['Product'],
    }),
    getAllOrders: builder.query({
      query: (
        tradeName = localStorage.getItem('name') || 'TPO',
      ) => ({
        url: `/getOrdersAdmin?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      transformResponse: (response) => response.reverse(),
      providesTags: ['ShipmentOrders'],
    }),
    getFastOrderItems: builder.query({
      query: (query) => ({
        url: '/getOrdersUniqueAdminByTradeName',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName: query.tradeName || '',
        },
      }),
      transformResponse: (
        response, //sort by name asc
      ) =>
        response.sort((a, b) => (a.name > b.name ? 1 : -1)),
    }),
    getAllOrdersEmitido: builder.query({
      query: (query) => ({
        url: `/getOrdersAdminEmitido`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName: localStorage.getItem('name') || 'TPO',
          limit: query.limit || 50,
          search: query.search || '',
          status: query.status
            ? query.status.map((obj) => obj._id).join(',')
            : '',
          platform: query.platform || '',
          tradeNames: query.tradeNames
            ? query.tradeNames.join(',')
            : '',
          deliveryDate: query.deliveryDate || '',
          month: query.month || '',
        },
      }),
      providesTags: ['ShipmentOrders'],
    }),
    getStatsOrders: builder.query({
      query: (
        tradeName = localStorage.getItem('name') || 'TPO',
      ) => ({
        url: `/getStatsOrdersAdmin?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['ShipmentOrders'],
    }),
    getOrdersEmetidoDashboard: builder.query({
      query: (query) => ({
        url: `/getOrdersAdminEmitido123`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName: localStorage.getItem('name') || 'TPO',
        },
      }),
      providesTags: ['ShipmentOrders'],
    }),
    getAllOrdersWithLimit: builder.query({
      query: (query) => ({
        url: `/getOrdersAdminLimit`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName: localStorage.getItem('name') || 'TPO',
          limit: query.limit || 50,
          search: query.search || '',
          status: query.status
            ? query.status.map((obj) => obj._id).join(',')
            : '',
          platform: query.platform || '',
          tradeNames: query.tradeNames
            ? query.tradeNames.join(',')
            : '',
          deliveryDate: query.deliveryDate || '',
          month: query.month || '',
          simpleDeliveryDate:
            query.simpleDeliveryDate || '',
          stockStatus: query.stockStatus || '',
        },
      }),
      providesTags: ['ShipmentOrders'],
    }),
    getOrdersShipment: builder.query({
      query: (query) => ({
        url: `/getOrdersAdminLimitShipment`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName: localStorage.getItem('name') || 'TPO',
          limit: query.limit || 50,
          search: query.search || '',
          status: query.status
            ? query.status.map((obj) => obj._id).join(',')
            : '',
          platform: query.platform || '',
          tradeNames: query.tradeNames
            ? query.tradeNames.join(',')
            : '',
          deliveryDate: query.deliveryDate || '',
          month: query.month || '',
        },
      }),
      providesTags: ['ShipmentOrders'],
    }),
    getTradeNamesFromContacts: builder.query({
      query: () => ({
        url: '/getTradeNamesFromContacts',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName: localStorage.getItem('name') || 'TPO',
        },
      }),
      transformResponse: (response) => response.reverse(),
      providesTags: ['TradeNames'],
    }),
    getOrdersByTradeName: builder.query({
      query: (tradeName) => ({
        url: `/getOrdersAdminByTradeName?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      transformResponse: (response) => response.reverse(),
    }),
    getAdressByTradeName: builder.query({
      query: (tradeName) => ({
        url: `/getAddressByTradename?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },

        method: 'GET',
      }),
    }),
    getAdressesByTradeNames: builder.query({
      query: (tradeNames) => ({
        url: `/getAdressesByTradeNames?tradeNames=${encodeURIComponent(tradeNames)}`,
        headers: {
          'Content-Type': 'application/json',
        },

        method: 'GET',
      }),
    }),
    getOrdersByTradeNameFilters: builder.query({
      query: (query) => ({
        url: `/getOrdersAdminByTradeNameFilters`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName: query.tradeName || '',
          limit: query.limit || 50,
          search: query.search || '',
          status: query.status
            ? query.status.map((obj) => obj._id).join(',')
            : '',
          platform: query.platform || '',
          tradeNames: query.tradeNames
            ? query.tradeNames.join(',')
            : '',
          deliveryDate: query.deliveryDate || '',
          month: query.month || '',
        },
      }),

      // transformResponse: (response) => response.reverse(),
    }),

    getOrdersById: builder.query({
      query: (id) => ({
        url: `/getOrdersAdmin/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['Order'],
    }),
    checkActualItems: builder.mutation({
      query: (body) => ({
        url: `/checkActualProducts`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    sendVerifactu: builder.mutation({
      query: (body) => ({
        url: `/sendFacturaVerifacti`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    getOrdersByIds: builder.query({
      query: (ids) => ({
        url: `/getOrdersByIds`,
        headers: {
          'Content-Type': 'application/json',
        },
        params: { ids }, // Use the array directly as the value for the 'ids' parameter
        method: 'GET',
      }),
      providesTags: ['ShipmentOrders'],
    }),
    getAllContacts: builder.query({
      query: (
        tradeName = localStorage.getItem('name') || 'TPO',
      ) => ({
        url: `/getContactsAdmin?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      transformResponse: (response) => response.reverse(),
      providesTags: ['Contacts'],
    }),
    getContactsForOrdersPageAdmin: builder.query({
      query: (
        tradeName = localStorage.getItem('name') || 'TPO',
      ) => ({
        url: `/getContactsForOrdersPageAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      transformResponse: (response) => response.reverse(),
      providesTags: ['Contacts'],
    }),

    getAllCotactsNew: builder.query({
      query: (query) => ({
        url: `/getContactsAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName: localStorage.getItem('name') || 'TPO',
          adminType: query.adminType || '',
        },
      }),
      transformResponse: (response) => response.reverse(),
      providesTags: ['Contacts'],
    }),
    getContactsById: builder.query({
      query: (id) => ({
        url: `/getContactsAdmin/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['Contact'],
    }),
    getContactByPhone: builder.query({
      query: (query) => ({
        url: `/getContactByPhoneAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          phone: query.phone,
        },
      }),
      providesTags: ['Contact'],
    }),
    getClientsAndOrders: builder.query({
      query: (query) => ({
        url: '/getClientsAndOrders',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          limit: query.limit || 20,
          search: query.search || '',
          adminType: query.adminType || '',
        },
      }),
      transformResponse: (response) => response.reverse(),
    }),
    getClientsAndOrdersAll: builder.query({
      query: () => ({
        url: '/getClientsAndOrdersAll',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      transformResponse: (response) => response.reverse(),
    }),
    createNewOrder: builder.mutation({
      query: (body) => ({
        url: '/createOrderAdminBrowser',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
    }),
    deleteOrder: builder.mutation({
      query: (id) => ({
        url: `/deleteOrderAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: {
          _id: id,
        },
        invalidatesTags: ['ShipmentOrders'],
      }),
    }),
    changeItemsInOrder: builder.mutation({
      query: (body) => ({
        url: `/updateOrderItemsAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    // store/services/mainApi.js (фрагмент)
    subscribeWhatsappSse: builder.query({
      // начальные данные — пустой список событий
      queryFn: () => ({ data: [] }),
      // ключ кэша — по номеру, чтобы на каждый phone была своя подписка
      serializeQueryArgs: ({ queryArgs }) =>
        queryArgs || '__all__',
      // как только кто-то подпишется — открываем SSE и стримим события в кэш
      async onCacheEntryAdded(
        phone,
        { updateCachedData, cacheEntryRemoved },
      ) {
        const url = phone
          ? `https://tpomobi.shop/rt/whatsapp?phone=${encodeURIComponent(phone)}`
          : 'https://tpomobi.shop/rt/whatsapp'
        const es = new EventSource(url)

        const handler = (ev) => {
          try {
            const payload = JSON.parse(ev.data) // { phone, message }
            updateCachedData((draft) => {
              draft.push(payload)
            })
          } catch {
            console.log('main api error')
          }
        }

        es.addEventListener('message', handler)
        es.addEventListener('error', () => {
          /* пусть переподключается браузер */
        })

        // когда хук отписался — закрываем соединение
        await cacheEntryRemoved
        es.close()
      },
      keepUnusedDataFor: 0,
    }),

    sendMessageToWhatsappClient: builder.mutation({
      query: (body) => ({
        url: `/sendMessageToWhatsappClient`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    updateStatusinOrder: builder.mutation({
      query: (body) => ({
        url: `/updateStatusOrderAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['LogisticOrders'],
    }),
    updateOrderDeliveryStatus: builder.mutation({
      query: (body) => ({
        url: `/updateOrderDeliveryStatus`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['LogisticOrders'],
    }),
    updateStatusinManyOrders: builder.mutation({
      query: (body) => ({
        url: `/updateStatusOrderAdminMany`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    payOrders: builder.mutation({
      query: (body) => ({
        url: `/updatePaidValueOrderAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    stockOrdersTrue: builder.mutation({
      query: (body) => ({
        url: `/updateStockOrderAdminTrue`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    stockOrdersFalse: builder.mutation({
      query: (body) => ({
        url: `/updateStockOrderAdminFalse`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    createContact: builder.mutation({
      query: (body) => ({
        url: '/createContactAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    deleteContact: builder.mutation({
      query: (id) => ({
        url: `/deleteContactAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          _id: String(id),
        }),
      }),
    }),
    updateContact: builder.mutation({
      query: (body) => ({
        url: `/updateContactAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    updateProduct: builder.mutation({
      query: (body) => ({
        url: `/updateProductAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    importContacts: builder.mutation({
      query: (body) => ({
        //form data
        url: `/importContactsAdmin`,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        method: 'POST',
        body,
      }),
      providesTags: ['Contacts'],
    }),
    // importProducts: builder.mutation({
    //   query: (body) => ({
    //     //form data
    //     url: `/importProductsAdmin`,
    //     headers: {
    //       'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
    //     },

    //     method: 'POST',
    //     body
    //   }),
    //   providesTags: ['Products'],
    // }),
    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `/deleteProductAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          _id: String(id),
        }),
      }),
    }),
    createProduct: builder.mutation({
      query: (body) => ({
        url: '/createProductAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeClient: builder.mutation({
      query: (body) => ({
        url: `/changeClientOrder`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    getAllStatuses: builder.query({
      query: (query) => ({
        url: `/getStatusAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          siteTradename:
            localStorage.getItem('name') || 'TPO',
        },
      }),
      providesTags: ['Statuses'],
    }),
    createStatus: builder.mutation({
      query: (body) => ({
        url: '/createStatusAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    // ----- endpoints -----
    getTopicYearResultsAdmin: builder.query({
      // usage: useGetTopicYearResultsAdminQuery({ year })
      query: ({ year } = {}) => {
        const y = normalizeYear(year)
        return {
          url: `/getTopicYearResultsAdmin?year=${encodeURIComponent(y)}`,
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        }
      },
      providesTags: (result, error, arg) => [
        // ✅ кэш и инвалидация по году (чтобы разные годы не мешались)
        {
          type: 'TopicYearResults',
          id: normalizeYear(arg?.year),
        },
      ],
    }),

    updateTopicYearResultsAdmin: builder.mutation({
      // usage: useUpdateTopicYearResultsAdminMutation()({ year, rootLabel, topicLabel, task })
      query: (body) => ({
        url: '/upsertTaskYearResultsAdmin',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: withYear(body),
      }),
      invalidatesTags: (result, error, arg) => [
        {
          type: 'TopicYearResults',
          id: normalizeYear(arg?.year),
        },
      ],
    }),

    addTopicCommentYearResultsAdmin: builder.mutation({
      // usage: ...({ year, rootLabel, topicLabel, type, text, rating, user })
      query: (body) => ({
        url: '/addTopicCommentYearResultsAdmin',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: withYear(body),
      }),
      invalidatesTags: (result, error, arg) => [
        {
          type: 'TopicYearResults',
          id: normalizeYear(arg?.year),
        },
      ],
    }),

    updateTopicCommentYearResultsAdmin: builder.mutation({
      // usage: ...({ year, rootLabel, topicLabel, type, commentId, text?, rating? })
      query: (body) => ({
        url: '/updateTopicCommentYearResultsAdmin',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: withYear(body),
      }),
      invalidatesTags: (result, error, arg) => [
        {
          type: 'TopicYearResults',
          id: normalizeYear(arg?.year),
        },
      ],
    }),

    // ---------------- OPTIONAL: если эти ручки тоже стали year-aware ----------------
    // Если твой backend /addTaskCommentYearResultsAdmin и /updateTaskPercentYearResultsAdmin
    // уже принимает year — оставляй так. Если нет — скажи, и я подгоню под текущие ручки.

    addTaskCommentYearResultsAdmin: builder.mutation({
      // usage: ...({ year, rootLabel, topicLabel, taskId, text, ... })
      query: (body) => ({
        url: '/addTaskCommentYearResultsAdmin',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: withYear(body),
      }),
      invalidatesTags: (result, error, arg) => [
        {
          type: 'TopicYearResults',
          id: normalizeYear(arg?.year),
        },
      ],
    }),

    updateTaskPercentYearResultsAdmin: builder.mutation({
      // usage: ...({ year, rootLabel, topicLabel, taskId, percent })
      query: (body) => ({
        url: '/updateTaskPercentYearResultsAdmin',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: withYear(body),
      }),
      invalidatesTags: (result, error, arg) => [
        {
          type: 'TopicYearResults',
          id: normalizeYear(arg?.year),
        },
      ],
    }),

    changeProductStatus: builder.mutation({
      query: (body) => ({
        url: `/updateStatusProductsAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeStatusAdmin: builder.mutation({
      query: (body) => ({
        url: `/updateNameOfStatusAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeBuisness: builder.mutation({
      query: (body) => ({
        url: `/updateTradeNameContactAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeDeliveryDate: builder.mutation({
      query: (body) => ({
        url: `/changeDeliveryDate`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ShipmentOrders', 'Routes'],
    }),
    sendNotificationOrderUpdateWhatsapp: builder.mutation({
      query: (body) => ({
        url: `/sendNotificationOrderUpdateWhatsapp`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    sendDocsOrderUpdateWhatsapp: builder.mutation({
      query: (body) => ({
        url: `/sendDocsOrderWhatsapp`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    sendFacturaWhatsapp: builder.mutation({
      query: (body) => ({
        url: `/sendFacturaDescargarWhatsapp`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    sendDriverInformSend: builder.mutation({
      query: (body) => ({
        url: `/driverInformSend`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    sendEmailBotWhatsapp: builder.mutation({
      query: (body) => ({
        url: `/sendEmailBotWhatsapp`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    sendBotStartWhatsapp: builder.mutation({
      query: (body) => ({
        url: `/sendBotStartWhatsapp`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeBuyerOrderPavilionObj: builder.mutation({
      query: (body) => ({
        url: `/updateBuyerOrderPavilionObjAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeBuyerOrderQuantityObj: builder.mutation({
      query: (body) => ({
        url: `/updateBuyerOrderQuantityObjAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeBuyerOrderPriceObj: builder.mutation({
      query: (body) => ({
        url: `/updateBuyerOrderPriceObjAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeOrderObj: builder.mutation({
      query: (body) => ({
        url: `/updateOrderObjAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeObjStock: builder.mutation({
      query: (body) => ({
        url: `/updateStockAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeObjStockMany: builder.mutation({
      query: (body) => ({
        url: `/updateProductsManagerMany`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
        invalidatesTags: ['ProductManager'],
      }),
    }),
    changeObjProveedor: builder.mutation({
      query: (body) => ({
        url: `/updateProveedorAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeObjEntryPrice: builder.mutation({
      query: (body) => ({
        url: `/updateEntryPriceAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeObjInform: builder.mutation({
      query: (body) => ({
        url: `/updateInformAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    changeOrderPaymentType: builder.mutation({
      query: (body) => ({
        url: `/updateOrderPaymentTypeAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeOrderDeliveryTime: builder.mutation({
      query: (body) => ({
        url: `/updateOrderDeliveryTimeAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeOrderDeliveryType: builder.mutation({
      query: (body) => ({
        url: `/updateOrderDeliveryTypeAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    getHistory: builder.query({
      query: (query) => ({
        url: `/getFacturaHistoryAdmin?tradeName=${localStorage.getItem('name') || 'TPO'}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          startDate: query.startDate || '',
          endDate: query.endDate || '',
        },
      }),
      transformResponse: (response) => response.reverse(),
      providesTags: ['History'],
    }),

    getHistoryPavilionProducts: builder.query({
      query: () => ({
        url: '/getHistoryPavilionProducts',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      // transformResponse: (response) => response.reverse(),
      providesTags: ['HistoryPavilion'],
    }),
    historyAndUpdatePavilionProducts: builder.mutation({
      query: (body) => ({
        url: `/historyAndUpdatePavilionProducts`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
      providesTags: ['History'],
    }),
    updateHistoryPavilionProducts: builder.mutation({
      query: (body) => ({
        url: `/updateHistoryPavilionProducts`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
      providesTags: ['History'],
    }),

    updateFacturaComment: builder.mutation({
      query: (body) => ({
        url: `/updateFacturaComment`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
      providesTags: ['History'],
    }),

    updateFacturaUpdateField: builder.mutation({
      query: (body) => ({
        url: `/updateFacturaUpdateField`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
      providesTags: ['History'],
    }),
    getLastNumInHistory: builder.mutation({
      query: (cuenta) => ({
        url: `/getLastNumFacturaHistoryAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: {
          cuenta: cuenta,
        },
      }),
      providesTags: ['History'],
    }),
    getUniqueCuentas: builder.query({
      query: () => ({
        url: `/getUniqueCuentasAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['History'],
    }),
    createNewHistoryValue: builder.mutation({
      query: (body) => ({
        url: `/createFacturaHistoryAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    deleteFromHistory: builder.mutation({
      query: (body) => ({
        url: `/deleteFacturaHistoryAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    updateStatusHistory: builder.mutation({
      query: (body) => ({
        url: `/updateFacturaHistoryAdminStatus`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
    }),
    updateNumFacturaHistory: builder.mutation({
      query: (body) => ({
        url: `/updateFacturaHistoryNumAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        providesTags: ['History'],
        method: 'PUT',
        body,
      }),
    }),
    payOrdersInFactura: builder.mutation({
      query: (body) => ({
        url: `/payOrdersAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    undoPaymentInFactura: builder.mutation({
      query: (body) => ({
        url: `/upPayOrdersAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    getFacturasByClient: builder.query({
      query: (query) => ({
        url: `/getFacturasByClientAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName: query.tradeName,
        },
      }),
      transformResponse: (response) => response.reverse(),
      providesTags: ['History'],
    }),
    importCategories: builder.mutation({
      query: (body) => ({
        url: `/importProductsLanding`,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        method: 'POST',
        body,
      }),
    }),
    changeDescription: builder.mutation({
      query: (body) => ({
        url: `/changeDescriptionOrder`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    changeInnerDescription: builder.mutation({
      query: (body) => ({
        url: `/changeInnerDescriptionOrder`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    updatePayValueInFacturaHistoryAdmin: builder.mutation({
      query: (body) => ({
        url: `/updatePayValueInFacturaHistoryAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    getSitesParams: builder.query({
      query: () => ({
        url: `/getSiteParams`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['SiteParams'],
    }),
    getSiteParamsByName: builder.query({
      query: (name) => ({
        url: `/getSiteParamsByName/${name}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    updateSiteParams: builder.mutation({
      query: (body) => ({
        url: `/updateSiteParams`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
    }),
    createSampleFile: builder.mutation({
      query: (body) => ({
        url: `/createSample`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    getSamples: builder.query({
      query: () => ({
        url: `/getSamples`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getSampleByName: builder.query({
      query: (name) => ({
        url: `/getSampleByName?name=${name}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    updateSample: builder.mutation({
      query: (body) => ({
        url: `/updateSample`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
    }),
    getUniqueCurrentUnits: builder.query({
      query: () => ({
        url: `/getUniqueCurrentUnits`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    //register admin
    loginAdmin: builder.mutation({
      query: (body) => ({
        url: `/auth`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    registerAdmin: builder.mutation({
      query: (body) => ({
        url: `/createAccAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    getSiteParamsById: builder.query({
      query: (query) => ({
        url: `/getSiteParamsById`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          _id: query._id,
        },
      }),
    }),
    getContactSupplierByTradeNameAdminArray: builder.query({
      query: (pavilions) => ({
        url: `/getContactSupplierByTradeNameAdminArray?tradeName=${pavilions}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),

    //personal sales

    getPersonalSales: builder.query({
      query: (tradeName) => ({
        url: `/getClientPersonalSales`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName,
        },
      }),
      providesTags: ['PersonalSales'],
    }),
    addPersonalSale: builder.mutation({
      query: (body) => ({
        url: `/addClientPersonalSales`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    updatePersonalSale: builder.mutation({
      query: (body) => ({
        url: `/updateClientPersonalSales`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    updateProductsManager: builder.mutation({
      query: (body) => ({
        url: `/updateProductsManager`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        invalidateTags: ['Products', 'ProductManager'],
        body,
      }),
    }),

    updateSpoPricePersonal: builder.mutation({
      query: (body) => ({
        url: `/updateSpoPricePersonal`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
    }),

    getLogs: builder.query({
      query: (params) => ({
        url: `/getLogs`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params,
      }),
    }),

    getFivgOperacionAdmin: builder.query({
      query: (tradeName) => ({
        url: `/getFivgOperacionAdminMulti?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),

    getFivgHistoryOperacionAdmin: builder.query({
      query: (tradeName) => ({
        url: `/getFivgOperacionAdminHistory?tradeName=${tradeName}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),

    getZumos: builder.query({
      query: (params) => ({
        url: `/getZumosOperacionAdmin?tradeName=${localStorage.getItem('name') || 'TPO'}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),

    getItemsOperacion: builder.query({
      query: (params) => ({
        url: `/getItemsOperacionAdmin?tradeName=${localStorage.getItem('name') || 'TPO'}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params,
      }),
      providesTags: ['itemsOperacion'],
    }),

    sendConfirmationWA: builder.mutation({
      query: (body) => ({
        url: `/sendProdToDriverTemplates`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    //drivers

    getDrivers: builder.query({
      query: () => ({
        url: `/driverListGet`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['Drivers'],
    }),

    driverListCreate: builder.mutation({
      query: (body) => ({
        url: `/driverListCreate`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    driverListUpdate: builder.mutation({
      query: (body) => ({
        url: `/driverListUpdate/${body._id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body: {
          name: body.name,
          phone: body.phone,
        },
      }),
    }),

    driverListDelete: builder.mutation({
      query: (id) => ({
        url: `/driverListDelete/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      }),
    }),

    historyPavItemDelete: builder.mutation({
      query: (id) => ({
        url: `/historyPavItemDelete/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      }),
    }),

    getBuisnessContactByTradeName: builder.query({
      query: (tradeName) => ({
        url: `/getBuisnessContactByTradeName`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName,
        },
        invalidatesTags: ['ContactBusiness'],
      }),
    }),
    getSuplierContactsByTradeName: builder.query({
      query: (tradeNames) => ({
        url: `/getSuplierContactsByTradeName?tradeNames=${encodeURIComponent(tradeNames)}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        invalidatesTags: ['ContactBusiness'],
      }),
    }),

    getOrderFromText: builder.query({
      query: (query) => ({
        url: `/parseCreateOrderAdmin?data=${encodeURIComponent(query)}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),

    sendOrdersToDriverTemplate: builder.mutation({
      query: (body) => ({
        url: `/sendOrdersToDriverTemplates`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    startEditingOrder: builder.mutation({
      query: (body) => ({
        url: `/startEditingOrder`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    finishEditingOrder: builder.mutation({
      query: (body) => ({
        url: `/finishEditingOrder`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    updateItemStatusInOrder: builder.mutation({
      query: (body) => ({
        url: `/changeStatusInProductWithOrder`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),
    updateItemRouteInOrder: builder.mutation({
      query: (body) => ({
        url: `/changeRouteInProductWithOrder`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    getProductsManagerBySku: builder.query({
      query: (body) => ({
        url: `/getProductsManagerBySku`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
        providesTags: ['ProductManager'],
      }),
    }),
    deleteStatusAdmin: builder.mutation({
      query: (body) => ({
        url: `/deleteStatusAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
        providesTags: ['Statuses'],
      }),
    }),

    uniteOrdersAdmin: builder.mutation({
      query: (body) => ({
        url: `/uniteOrdersAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    moveItemFromOrderToOrder: builder.mutation({
      query: (body) => ({
        url: `/moveItemsFromOrderToOrder`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    getProductsWithLowProfit: builder.query({
      query: ({
        search,
        limit,
        onlyZeroOrNegative,
        onlyZeroCogs,
      }) => ({
        url: `/getProductsWithLowProfit`,
        headers: {
          'Content-Type': 'application/json',
        },
        params: {
          search,
          limit,
          onlyZeroOrNegative,
          onlyZeroCogs,
        },
        method: 'GET',
      }),
    }),

    allReadyItems: builder.mutation({
      query: (body) => ({
        url: `/allReadyItems`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    getActualOrdersByTradeName: builder.query({
      query: (tradeName) => ({
        url: `/getOrdersByTradeName`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          tradeName,
        },
      }),
    }),

    //buyer
    addBuyerProduct: builder.mutation({
      query: (body) => ({
        url: `/addToAdminBuyerProduct`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BuyerProducts'],
    }),

    getBuyerProducts: builder.query({
      query: () => ({
        url: `/getAdminBuyerProducts`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['BuyerProducts'],
    }),

    updatePavilionBuyerProduct: builder.mutation({
      query: (body) => ({
        url: `/updatePavilionBuyerProduct`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BuyerProducts'],
    }),

    editBuyerProduct: builder.mutation({
      query: (body) => ({
        url: `/editBuyerProduct`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BuyerProducts'],
    }),
    editBuyerProductHistory: builder.mutation({
      query: (body) => ({
        url: `/editBuyerProductHistory`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BuyerHistoryProducts'],
    }),

    updateQuantityBuyerProduct: builder.mutation({
      query: (body) => ({
        url: `/updateQuantityBuyerProduct`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BuyerProducts'],
    }),

    updatePriceBuyerProduct: builder.mutation({
      query: (body) => ({
        url: `/updatePriceBuyerProduct`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BuyerProducts'],
    }),

    updateByerProduct: builder.mutation({
      query: (body) => ({
        url: `/updateBuyerProduct`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BuyerProducts'],
    }),

    updateIsBlockedArrayAdmin: builder.mutation({
      query: (body) => ({
        url: `/updateIsBlockedArrayAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: { orders: body },
      }),
    }),

    updateStatusBuyerProduct: builder.mutation({
      query: (body) => ({
        url: `/updateStatusBuyerProduct`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BuyerProducts'],
    }),
    updateStatusBuyerProductHistory: builder.mutation({
      query: (body) => ({
        url: `/updateStatusBuyerProductHistory`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BuyerHistoryProducts'],
    }),

    getAllPavilions: builder.query({
      query: () => ({
        url: `/getAllPavilions`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      invalidatesTags: ['BuyerProducts'],
    }),

    getAllPavObj: builder.query({
      query: () => ({
        url: `/getAllPavObj`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    getItemsProcessingAdmin: builder.query({
      query: () => ({
        url: `/getItemsProcessingAdmin`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),

    deleteFromBuyerProduct: builder.mutation({
      query: ({ _id }) => ({
        url: `/deleteAdminBuyerProduct?_id=${_id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['BuyerProducts'],
    }),

    payPavInBuyer: builder.mutation({
      query: (body) => ({
        url: `/updateAdminBuyerProductPayment`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['BuyerProducts'],
    }),

    payMultiProductsInBuyer: builder.mutation({
      query: (body) => ({
        url: `/payMultipleProducts`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['BuyerProducts'],
    }),
    // buyer history

    getBuyerProductsHistory: builder.query({
      query: () => ({
        url: `/getBuyerProductHistory`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['BuyerHistoryProducts'],
    }),
    addTobuyerHistory: builder.mutation({
      query: (body) => ({
        url: `/addBuyerProductHistory`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BuyerHistoryProducts'],
    }),
    updatePaidByTradeNameContactAdmin: builder.mutation({
      query: (body) => ({
        url: './updatePaidByTradeNameContactAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    updateContactPaidValue: builder.mutation({
      query: (body) => ({
        url: './updateContactPaidValue',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    getStock: builder.query({
      query: () => ({
        url: `/getStash`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        invalidatesTags: ['Stock'],
      }),
    }),

    createStock: builder.mutation({
      query: (body) => ({
        url: `/createStash`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
    }),

    updateStock: builder.mutation({
      query: (body) => ({
        url: `/updateStash/${body._id}`,
        body,
      }),
    }),
    getAdminAccById: builder.query({
      query: (id) => ({
        url: './getAdminAccById/' + id,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    updatePaidAdminAcc: builder.mutation({
      query: (body) => ({
        url: './updatePaidAdminAcc',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PUT',
        body: body,
      }),
    }),
    updateTelegramDataAdminAcc: builder.mutation({
      query: (body) => ({
        url: './updateTelegramDataAdminAcc',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: body,
      }),
    }),

    //logistic

    getLogistic: builder.query({
      query: () => ({
        url: `/getLogisticOrders`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: (result) =>
        result ? ['LogisticOrders'] : [], // ✅ теперь будет матчиться
    }),

    //shipment items in contact

    updateShipmentItems: builder.mutation({
      query: (body) => ({
        url: '/updatePavilionProducts',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: body,
      }),
    }),

    //logistic

    // VANS
    getVans: builder.query({
      query: () => '/vans',
    }),
    getVanById: builder.query({
      query: (id) => ({
        url: `/vans/${id}`,
        method: 'GET',
      }),
    }),
    createVan: builder.mutation({
      query: (body) => ({
        url: '/vans',
        method: 'POST',
        body,
      }),
    }),
    updateVan: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/vans/${id}`,
        method: 'PUT',
        body,
      }),
    }),
    deleteVan: builder.mutation({
      query: (id) => ({
        url: `/vans/${id}`,
        method: 'DELETE',
      }),
    }),

    // ROUTES
    getRoutes: builder.query({
      query: () => '/routes',
      providesTags: ['Routes'],
    }),
    createRoute: builder.mutation({
      query: (body) => ({
        url: '/routes',
        method: 'POST',
        body,
      }),
    }),
    updateRoute: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/routes/${id}`,
        method: 'PUT',
        body,
      }),
    }),
    deleteRoute: builder.mutation({
      query: (id) => ({
        url: `/routes/${id}`,
        method: 'DELETE',
      }),
    }),
    updateOrderLogistic: builder.mutation({
      query: (body) => ({
        url: '/updateOrderLogistic',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      }),
    }),
    moveOrderLogistic: builder.mutation({
      query: (body) => ({
        url: '/routes/moveOrder',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      }),
      invalidatesTags: ['LogisticOrders', 'Routes'],
    }),
    startRoute: builder.mutation({
      query: (id) => ({
        url: `/routes/${id}/start`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Routes', 'LogisticOrders'],
    }),
    stopRoute: builder.mutation({
      query: (id) => ({
        url: `/routes/${id}/stop`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Routes', 'LogisticOrders'],
    }),

    getLogisticHistory: builder.query({
      query: (params) => ({
        url: `/routesHistory`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        params,
      }),
      invalidatesTags: ['LogisticHistory'],
    }),
    doneOrder: builder.mutation({
      query: (id) => ({
        url: `/orders/${id}/done`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      // динамическая инвалидизация
      invalidatesTags: (result, error, { id }) => {
        if (result?.routeEmpty) {
          return ['LogisticOrders', 'Routes']
        }
        return ['LogisticOrders']
      },
    }),

    updateRouteOrders: builder.mutation({
      query: (body) => ({
        url: '/updateRouteOrders',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      }),
    }),

    importPersonalSales: builder.mutation({
      query: (body) => ({
        url: '/importPersonalPrices',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      }),
    }),
    getMatchesList: builder.query({
      query: () => ({
        url: `/getMatchesList`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
    }),
    exportProductManagerInventarizationAdmin:
      builder.mutation({
        query: (sku) => ({
          url: '/exportProductManagerInventarizationAdmin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: { sku: sku },
        }),
      }),

    //SALES ROUTES
    createSale: builder.mutation({
      query: (body) => ({
        url: '/sales',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Sales'],
    }),
    getSales: builder.query({
      query: () => ({
        url: '/sales',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['Sales'],
    }),
    deleteSale: builder.mutation({
      query: (id) => ({
        url: `/sales/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      }),
      invalidatesTags: ['Sales'],
    }),
    updateSales: builder.mutation({
      query: (body) => ({
        url: `/sales/${body.id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PATCH',
        body: body.data,
      }),
      invalidatesTags: ['Sales'],
    }),
    activateSale: builder.mutation({
      query: (id) => ({
        url: `/sales/${id}/activate`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PATCH',
      }),
      invalidatesTags: ['Sales'],
    }),
    deactivateSale: builder.mutation({
      query: (id) => ({
        url: `/sales/${id}/deactivate`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PATCH',
      }),
      invalidatesTags: ['Sales'],
    }),
    getAdminProductsRecent: builder.query({
      query: ({ days }) => ({
        url: '/getAdminProductsRecent6d',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: { days: days ? days : 6 },
      }),
    }),

    // Debtors
    getAllDebtors: builder.query({
      query: () => ({
        url: '/getAllDebtors',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
      }),
      providesTags: ['Debtors'],
    }),

    // Route Trade Names
    getRouteTradeNames: builder.query({
      query: () => ({
        url: '/getRouteTradeNames',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      transformResponse: (response) => {
        // Обрабатываем ответ от Express.js API
        if (
          response &&
          response.success &&
          Array.isArray(response.data)
        ) {
          return response.data
        }
        return []
      },
      providesTags: ['RouteTradeNames'],
    }),

    getRouteTradeNamesByRoute: builder.query({
      query: (routeId) => ({
        url: `/getRouteTradeNames/${routeId}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      transformResponse: (response) => {
        if (response && response.success && response.data) {
          return response.data
        }
        return null
      },
      providesTags: ['RouteTradeNames'],
    }),

    updateRouteTradeNames: builder.mutation({
      query: (body) => ({
        url: '/updateRouteTradeNames',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['RouteTradeNames'],
    }),

    bulkUpdateRouteTradeNames: builder.mutation({
      query: (body) => ({
        url: '/bulkUpdateRouteTradeNames',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['RouteTradeNames'],
    }),

    deleteRouteTradeNames: builder.mutation({
      query: (routeId) => ({
        url: `/deleteRouteTradeNames/${routeId}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      }),
      invalidatesTags: ['RouteTradeNames'],
    }),

    // Driver Comments API
    getDriverComments: builder.query({
      query: (orderId) => ({
        url: `/getDriverComments/${orderId}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: (result, error, orderId) => [
        { type: 'DriverComments', id: orderId },
      ],
    }),

    updateDriverComment: builder.mutation({
      query: (body) => ({
        url: '/updateDriverComment',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { orderId }) => [
        { type: 'DriverComments', id: orderId },
        { type: 'Order', id: orderId },
      ],
    }),

    uploadDriverCommentImage: builder.mutation({
      query: (formData) => ({
        url: '/uploadDriverCommentImage',
        method: 'POST',
        body: formData,
      }),
    }),

    // User Management API
    getUsers: builder.query({
      query: () => ({
        url: '/getUsers',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: ['Users'],
    }),

    createUser: builder.mutation({
      query: (userData) => ({
        url: '/createAccAdmin',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: { data: userData },
      }),
      invalidatesTags: ['Users'],
    }),

    updateUser: builder.mutation({
      query: ({ id, data }) => ({
        url: '/updateUser',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: { id, data },
      }),
      invalidatesTags: ['Users'],
    }),

    deleteUser: builder.mutation({
      query: (userId) => ({
        url: '/deleteUser',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: { id: userId },
      }),
      invalidatesTags: ['Users'],
    }),

    getUserById: builder.query({
      query: (userId) => ({
        url: `/getUser/${userId}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: (result, error, userId) => [
        { type: 'User', id: userId },
      ],
    }),
  }),
})
